import { useEffect, useRef } from 'react'
import { VideoContext } from '../../context/viddyVideoContext'
import { useVideoContextSetup } from '../../hooks/useViddyCoreAndVideoContextSetup'

export const VideoContextProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const isFirstRender = useRef(true)

    const videoContextStore = useVideoContextSetup()
    const { setIsBlurred } = videoContextStore

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
    }, [videoContextStore.isMuted])

    // Set blur variable
    useEffect(() => {
        const onBlur = () => {
            setIsBlurred(true)
        }

        const onFocus = () => {
            setIsBlurred(false)
        }

        window.addEventListener('blur', onBlur)
        window.addEventListener('focus', onFocus)

        return () => {
            window.removeEventListener('blur', onBlur)
            window.removeEventListener('focus', onFocus)
        }
    }, [])

    return (
        <VideoContext.Provider value={videoContextStore}>
            {children}
        </VideoContext.Provider>
    )
}
